<label
  *ngIf="label"
  class="flex items-center text-sm cursor-text font-semibold mb-1"
  [class.text-sky-grey]="formControl.disabled"
  [class.text-sky-red]="formControl.touched && formControl.invalid"
  [class.text-sky-blue]="focused"
>
  <span>{{ label }}</span>
  <sky-tooltip-badge *ngIf="tooltip" [message]="tooltip"></sky-tooltip-badge>
</label>
<span class="flex items-center">
  <span *ngIf="prefix">{{prefix}}&nbsp; </span>
  <input
    [formControl]="formControl"
    [type]="inputType"
    class="flex-1 border-sky-grey focus:outline-none py-2 px-3 rounded-xl focus:border-sky-blue border"
    [class.text-sky-grey]="formControl.disabled"
    [class.pr-7]="icon"
    [class.border-sky-red]="formControl.touched && formControl.invalid"
    [placeholder]="placeholder"
    (keydown)="testUserInput($event)"
    (focus)="focused = true"
    (blur)="focused = false"
  />
</span>
<ng-content></ng-content>
